import React from 'react'
import swal from "sweetalert";
import IrrDownloadModal from './IrrDownloadModal'
import { Button, Icon } from 'semantic-ui-react'
import { Link } from "react-router-dom";
import { MDBBtn } from 'mdbreact'
import colors from '../colors'
export default class IrrTable extends React.Component {
  state = {
    modal: false,
  }
  handleDownload =  () => {
    this.props.handleSubmitDisable()
    this.setState({
      modal: true
    })
    // if (window.sessionStorage.getItem("loginUser") !== null) {
   
    // }
    // else {
    //   swal({
    //     title: `Message`,

    //     padding: "3em",

    //     text:
    //       " Please Login",
    //   });

    //   //   try {
    //   //     cas.redirect();
    //   //     let result=await cas.getLogin()
    //   //     console.log(result)
    //   //   } catch (err) {
    //   //     if (err.error !== "login_required") console.log("error: " + err);
    //   //   }
    //   // }
    // }
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }
  seasonChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.setState({
        season: s
      })
    }
  };
  yearChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.setState({
        year: s

      })
    }
  };
  render() {
    let cropyears,cropseasons
    if(this.props.cropmapyears)
    {
      cropyears=this.props.cropmapyears.map((result)=>{
        return(<option value={result.year}>{result.year}</option>)
      })
    }
    if(this.props.cropmapseasons)
    {
      cropseasons=this.props.cropmapseasons.map((result)=>{
        return(<option value={result.season}>{result.season}</option>)
      })
    }
    return (
      <div>
        {this.state.modal ? <IrrDownloadModal modal={this.state.modal} title="Narayanpur Irrigation Command Crop Maps" toggle={this.toggle} year={this.props.cropyear} season={this.props.cropseason} theme="Irrigation"
          product="cropmap"
          user={window.sessionStorage.getItem("loginUser")}
        /> : null}
        <div className="wrapper_data">


          <div id="one">
            Select Year
            <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleYear}
              value={this.props.cropyear}
              selected={this.props.cropyear}

            >
              <option value="#">Select Year</option>
              {/* <option value="2020" selected>
                2020
              </option> */}
            {cropyears}
              {/* <option value="2013">2013</option> */}
            </select>
            Select Season
            <select
              style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleSeason}
              value={this.props.cropseason}
              selected={this.props.cropseason}

            >
              <option value="#">Select Season</option>
             {cropseasons}
            </select>
          </div>

          <div id="two">
            {
              this.props.cropyear !== '#' && this.props.cropseason !== '#' && !this.props.submitdisable?
                <button
                  onClick={this.handleDownload}
                  className="btn btn-primary text-capitalize"
                >
                  Submit
              </button>
                : null
            }



          </div>

        </div>
        {/* <Button animated>
                    <Link to="/webgis-irrigation/map">   <Button.Content visible>Geoportal</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Link>
                </Button> */}
      </div>
    )
  }
}